import { useEffect, useRef } from 'react'

// Ensafely brand favicon: the SIGN mark (swoosh + dot). The dot carries the
// health signal — brand green when all checks pass, alert red when any fail.
// Mirrors the static Ensafely-FAV_*.svg assets shipped by the design team.
function createFaviconSVG(isHealthy: boolean): string {
  const dot = isHealthy ? '#23c120' : '#f23a16'
  return `data:image/svg+xml,${encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><circle cx="8.01" cy="5.96" r="1.81" fill="${dot}"/><path d="M16 1.32s-1.56 1.82-2.46 3.4c-.54.94-.91 1.9-.91 1.9.07-.15.09-.78-.19-1.49-.43-1.1-1.55-2.34-3.64-2.38-.71-.01-1.5.25-2.04.66-.84.64-1.4 1.66-1.09 3.28 0 .02-1.28-2 .25-3.81C7.21 1.35 9.46.87 12.16.87c1.33 0 2.72.23 3.84.46ZM9.81 7.56c-1.24 1.08-2.41 1.1-3.38.7C5.8 8 5.18 7.45 4.84 6.82c-1-1.82-.49-3.42.25-4.34.48-.6 1.03-.9 1.2-.91 0 0-1.01.16-2.1.16C2.36 1.74 0 1.3 0 1.3c.36 1.08.86 2.4 1.52 3.55 1.35 2.34 2.89 4.05 4.86 4.4 2.33.42 3.44-1.7 3.43-1.69M8.5 3.51c1.56.54 2.16 1.54 2.29 2.58.09.68-.08 1.49-.45 2.1-1.08 1.78-2.72 2.13-3.88 1.96-.76-.11-1.29-.44-1.39-.58 0 0 .64.8 1.19 1.73.92 1.57 1.71 3.83 1.71 3.83s.03-.03.04-.05l-.03.05s.07-.09.2-.23c.71-.81 1.5-1.81 2.1-2.86 1.35-2.33 2.06-4.52 1.38-6.4-.81-2.23-3.19-2.13-3.17-2.12Z" fill="#0051aa"/></svg>`)}`
}

export function useFavicon(unhealthyCount: number, totalEnabled: number) {
  // Capture the document title set by index.html on first mount so the
  // host app's branding (e.g. "Ensafely — Monitoring Dashboard") survives
  // subsequent title updates. Strip any "(N failing) " prefix in case we
  // re-mount after a prior update.
  const baseTitleRef = useRef<string | null>(null)
  if (baseTitleRef.current === null) {
    baseTitleRef.current = document.title.replace(/^\(\d+ failing\)\s*/, '')
  }

  useEffect(() => {
    if (totalEnabled === 0) return

    const isHealthy = unhealthyCount === 0
    const href = createFaviconSVG(isHealthy)

    let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]')
    if (!link) {
      link = document.createElement('link')
      link.rel = 'icon'
      document.head.appendChild(link)
    }
    link.type = 'image/svg+xml'
    link.href = href

    const baseTitle = baseTitleRef.current ?? 'Checker'
    document.title = unhealthyCount > 0
      ? `(${unhealthyCount} failing) ${baseTitle}`
      : baseTitle
  }, [unhealthyCount, totalEnabled])
}
